import React from 'react'
import { array, bool, string, node } from 'prop-types'
import { css } from '@emotion/react'

import mediaQueries from '@/layout/media-queries'
import ProductCard from '@/components/Product/Card'

const appsWrapperCss = css`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: 20px;

  ${mediaQueries.xlargeScreen()} {
    margin-left: -20px;
    margin-right: -20px;
  }
`

const ProductListVertical = ({
  items,
  installedApps = [],
  cardComponent: CardComponent = ProductCard,
  className,
  isFeatured,
  useLegacyButtons,
  isPrivateApp,
}) => {
  return (
    <div css={appsWrapperCss} data-test="appsComponent" className={className}>
      {items?.map((item) => (
        <CardComponent
          isFeatured={isFeatured}
          key={item.id}
          app={{
            ...item,
            isInstalled: installedApps.indexOf(item.id) > -1,
            useLegacyButtons,
            isPrivateApp,
          }}
        />
      ))}
    </div>
  )
}

ProductListVertical.propTypes = {
  items: array,
  installedApps: array,
  cardComponent: node,
  className: string,
  isFetching: bool,
  isFeatured: bool,
  useLegacyButtons: bool,
  isPrivateApp: bool,
}

export default ProductListVertical
